import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { SSOResponse } from './singleSignOn.service';
import { IStoreActionsService } from '@services/storeActions.service';
import { ILoginResult } from './authentication.service';

export interface IEntraIdSignOnService {
    login(accessToken: string): angular.IPromise<ILoginResult>;
}

export class EntraIdSignOnService implements IEntraIdSignOnService {
    static serviceId = 'entraIdSignOnService';
    static $inject = ['$http', 'requestService', 'storeActionsService'];

    private _controllerUrl = 'AzureSignOn';

    constructor(private _$http: angular.IHttpService, private _requestService: IRequestService, private _storeActionsService: IStoreActionsService) {}

    login(accessToken: string): angular.IPromise<ILoginResult> {
        const request: angular.IRequestConfig = {
            method: 'GET',
            url: this._requestService.getUrlV1() + this._controllerUrl,
            headers: {
                azureToken: accessToken
            }
        };

        return this._$http<SSOResponse>(request).then((response) => this.doLogin(response.data));
    }

    private doLogin(data: SSOResponse): angular.IPromise<any> {
        return this._storeActionsService.authentication.login({ userName: data.login, password: undefined, session: data.sessionId });
    }
}
